"use client";
import { useI18n } from "@/i18n/provider";
import { clientMessages } from "@/i18n/client-messages";
export default function ErrorPage({ reset }: { error: Error & { digest?: string }; reset: () => void }) {
  const { locale } = useI18n();
  const t = clientMessages[locale];
  return <main id="main" className="centered-page"><p className="eyebrow">{t.pauseEyebrow}</p><h1>{t.connectionLost}</h1><p>{t.pageError}</p><button className="button button-dark" onClick={reset}>{t.retry}</button></main>;
}
